import { Icon, IconName } from "components/Icon";
import { Link, useMatch } from "react-router-dom";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}
export default function Sidebar() {
  const match = useMatch("/dashboard/clients/:childPath/*");
  const childPath = match?.params.childPath ?? "/";
  type NavigationItem = {
    name: string;
    href: string;
    icon: string;
    current: boolean;
    isOpenInNewTab?: boolean;
  };

  const adminNavigation: NavigationItem[] = [
    {
      name: "All Clients",
      href: "all-clients",
      icon: "groups",
      current: childPath === "all-clients" || childPath === "/",
    },
    {
      name: "Expiring documents",
      href: "/dashboard/expiringDocuments",
      icon: "greyDocument",
      current: childPath === "expiringDocuments",
    },
    {
      name: "Archived accounts",
      href: "/dashboard/archivedAccounts",
      icon: "solidArchive",
      current: childPath === "archivedAccounts",
      isOpenInNewTab: true,
    },
  ];

  return (
    <nav className="flex flex-1 flex-col" aria-label="Sidebar">
      <ul className="space-y-1">
        {adminNavigation.map((item) => (
          <li key={item.name} className="!m-0">
            <Link
              to={item.href}
              className={classNames(
                item.current
                  ? "bg-primary-100 text-gray-900 hover:bg-primary-200"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-200",
                "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
              )}
              target={item.isOpenInNewTab ? "_blank" : undefined}
              rel={item.isOpenInNewTab ? "noopener noreferrer" : undefined}
            >
              {item.icon && (
                <Icon
                  name={item.icon as IconName}
                  className={classNames(
                    item.current
                      ? "text-gray-900"
                      : "text-gray-600 group-hover:text-gray-900 hover:text-gray-900",
                    "h-5 w-5 shrink-0"
                  )}
                />
              )}
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
